export const chevronRightPath = "<path d=\"M6 4 L10 8 L6 12\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>"
